import React, { useContext, useState } from 'react';
import { ProductContext, AccountContext, GlobalContext } from '@components/Context';
import { useGetPrice } from '@lib/hooks';
import Tag from '@components/Tag';
import { isLogin, goToDownload, isMobile } from '@lib/utils';
import history from '@lib/history';
import './product-info.scss';
import SessionStorage from '@/lib/session';
import { BXL_UTM_PARAMS, SMZDM, STAIC_ORIGIN } from '@lib/constants';
import Download from '@modules/Common/Download';
const directShipping = require('@images/protect_mini_direct_shipping.png').default;
const qualityProduct = require('@images/protect_mini_quality_product.png').default;
const robot = require('@images/protect_mini_robot.png').default;

interface ProductInfoProps {

}

function ProductInfo(props: ProductInfoProps) {
    const context: any = useContext(ProductContext);
    const accountContext: any = useContext(AccountContext);
    const globalContext: any = useContext(GlobalContext);
    const price: any = useGetPrice();
    const { gender, brand, nameCN, name, displayBrand, id, hideModule } = context.product || {};
    const promotions = context?.product?.promotions || {};
    const utmParam = JSON.parse(SessionStorage.get(BXL_UTM_PARAMS) || '{}');
    const [visible, setVisible] = useState(false);

    function goToLogin() {
        if(isMobile()) {
            goToDownload();
        } else {
            setVisible(true);
        }
    }

    function handleProtectClick() {
        const link = `${STAIC_ORIGIN}/static/html/qualityPage/index.html`
        globalContext.updateIframeLink(link);
        history.push('/iframe');
    }

    return (
        <div className='m-product-info'>
            <div className='preview-price'>
                <div className='price'>{price?.priceTag}</div>
                <div className='original-price'>{price?.originalPriceTag}</div>
            </div>
            <div className='main-price'><span className='small'>约</span>{price?.priceTagCN}</div>
            {(promotions.promoBadges && promotions.promoBadges.length) ?
                <div className='promotion-tags'>
                    <Tag>特惠</Tag>
                    {promotions.promoBadges.map((item: any, index: number) => {
                        return (
                            <div key={index} className='tag'>{item.badges[0]}</div>
                        )
                    })}
                </div> : null
            }
            <div className='main-title'>{gender} {displayBrand || brand} | {nameCN || name}</div>
            {(nameCN && name) ? <div className='sub-title'>{brand} | {name}</div> : null}
            {!hideModule?.hide &&
                <div className='protect-bar' onClick={handleProtectClick}>
                    <div className='protect-item'>
                        <img src={robot} />
                        <div className='label'>机器人下单</div>
                    </div>
                    <div className='protect-item'>
                        <img src={directShipping} />
                        <div className='label'>官网直邮</div>
                    </div>
                    <div className='protect-item'>
                        <img src={qualityProduct} />
                        <div className='label'>100%正品</div>
                    </div>
                </div>
            }
            {(!isLogin() && !accountContext.loginState) && (utmParam?.utmSource !== SMZDM) &&
                <div className='go-login-wrap' onClick={goToLogin}>
                    <div className='tips-wrap'>
                        <div className='new-user-tag'>新人</div>
                        <div className='tips-text'>注册送{accountContext?.newcomer?.priceWithCurrencySymbolAndText}新人礼包</div>
                    </div>
                    <div className='go-login'>登录领取</div>
                </div>
            }
            {visible && <Download onClose={() => setVisible(false)} />}
        </div>
    )
}

export default ProductInfo;